import React from 'react'
import { Card, ButtonGroup, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const NotificationMessage = (props) => {
  const { currentNotification } = props

  const message = {__html: currentNotification.message}

  const messageDiv = (
    <div dangerouslySetInnerHTML={message}>
    </div>
  )

  const handleToggleNotificationPin = () => {
    return props.togglePinNotification(currentNotification, !currentNotification.is_pinned, props)
  }

  const handleDeleteNotification = () => {
    return props.deleteNotification(currentNotification, props)
  }

  return (
    <Card className='notification-message'>
      {messageDiv}
      <br/>

      {currentNotification.route ?
        <Link to={currentNotification.route}>
          Click here to view
        </Link>
        :
        null
      }

      <br/>

      <ButtonGroup>
        <Button variant='outline-primary' onClick={handleToggleNotificationPin}>
          {currentNotification.is_pinned ?
            'Unpin Notification'
            :
            'Pin Notification'
          }
        </Button>

        <Button
          variant='outline-danger'
          onClick={handleDeleteNotification}
        >
          Delete Notification
        </Button>
      </ButtonGroup>
    </Card>
  )
}

export default NotificationMessage
